<template>
  <div>

    <!-- bg_stars -->
    <div class="ui-bg-stars">
    </div>
    
    <!-- banner -->
    <div class="ui-uni-banner">
      <div class="container ref">
        <div class="title-box">
          <h1>
            {{lg('',{
              en: 'Explore the lions',
              zh: '淘狮子',
            })}}
          </h1>
          <div>
            {{lg('',{
              en: 'Discover every option',
              zh: '快来Explore所有狮子王国的狮子',
            })}}
          </div>
        </div>

        <img 
          class="banner-img" 
          src="/static/img/bg_uni_banner_01.png?v=2" 
          style="height: 200px; right:10px; bottom: -18px;"
        >
      </div>
    </div>

    <!-- search -->
    <div v-if="0" class="py-4 mt-3 bg-c-light">
      <div class="container">
        <searchBox
          :search_options="search_options"
        />
      </div>
    </div>

    <div class="container my-5">
      <div v-if="status_ajaxing_list" class="text-muted text-center py-3">
        <span class="op5">Loading...</span>
      </div>
      <div v-else>
        <div class="sp-list-main">
          <div
            v-for="item of list_all"
            :key="item"
            class="sp-item"
            >
            <lionItem
              :data="item"
              :cfg_hide_header="true"
              :cfg_show_price_row="true"
            />
          </div>
        </div>
        <div>
          <pagination
            mix_class="justify-content-center"
            :conf="pagination_cfg"
            @reloadList="action_getAllHorse()"
          />
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import searchBox from '@/views/explore/search_box.vue'
import lionItem from '@/views/_cp_busi/lion_item.vue'
import pagination from '@/views/_cp_base/pagination.vue'
import {mapActions} from 'vuex'

export default {
  name: 'explore',
  components: {
    searchBox,
    lionItem,
    pagination,
  },
  props: [],
  data() {
    return {
      list_all: [],
      status_ajaxing_list: false,


      search_options: {

      },

      pagination_cfg: {
        'page_size': 12, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': null, //总个数，和总页数选填其一
        'btn_num': 10, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages': 800, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions([
      'getAllHorse',
    ]),

    async action_getAllHorse(){
      let v = this
      
      v.status_ajaxing_list = true
      let res = await this.getAllHorse({
        page: v.pagination_cfg.page_current,
        numPerPage: v.pagination_cfg.page_size,
      })

      res = res.map(i => v.transHorseData(i))
      v.status_ajaxing_list = false
      v.list_all = res
    },
    run(){
      this.action_getAllHorse()
    },
  },
  created() {
    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>